import { render, staticRenderFns } from "./StatusComment.vue?vue&type=template&id=27012a3a&"
import script from "./StatusComment.vue?vue&type=script&lang=js&"
export * from "./StatusComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports